import { getClub } from "./cookie.utils";

// Logging
var AAAtag = {
    logEventAction: function (site, domain, page, eventType, event) {
      if (location.href.indexOf('localhost') != -1) return;
  
      if (typeof window !== 'undefined') {
        var appId = '';
        var refUrl = '';
        try {
          appId = (document.cookie.match(
            /^(?:.*;)?\s*seo_ref_url\s*=\s*([^;]+)(?:.*)?$/
          ) || ["", 'SEO'])[1];
          refUrl = (document.cookie.match(
            /^(?:.*;)?\s*seo_ref_url\s*=\s*([^;]+)(?:.*)?$/
          ) || ["", '.'])[1];
        } catch (e) {
            console.log("could not get appId or refUrl from cookie");
        }
        if (appId.match(/aaa\.com/)) {
          appId = 'AAACOM';
        } else {
          appId = 'SEO';
        }
        try{
          var club = getClub();
          var attrs = {
            site,
            domain,
            page,
            action: event,
            eventAction: eventType,
            appId: appId,
            club: club,
            refUrl: refUrl,
            vendor_name: "Hertz",
            business_line_product: "Hertz Premier Gold"
          };
          if (window.lc_logEvent) window.lc_logEvent(attrs);
        }catch(e){
          console.log(e)
        }
      }
    },
  };

/* global adobeAnalytics_logEvent,adobeAnalyticsEvents */
export function logPageView(site, domain, page, clubCode) {

    // Try to log for both
    logPageView_google(site, domain, page, clubCode,true);
    logPageView_adobe(site, domain, page, clubCode,true);
}
export function logPageView_google(site, domain, page, clubCode,retry=true) {
    if (typeof AAAtag !== 'undefined') {
        AAAtag.logEventAction(site, domain, page, 'PAGEVIEW');
      }else if(retry){

        // Wait for 2  seconds before trying again, but dont retry this time
        setTimeout(function(){
            logPageView_google(site, domain, page, clubCode,false);
        }, 2000);
      }
}

export function logPageView_adobe(site, domain, page, clubCode,retry=true) {
   
    if (typeof adobeAnalytics_logEvent !== 'undefined') {
      adobeAnalytics_logEvent(adobeAnalyticsEvents.PAGEVIEW, {
        vendor_name: "Hertz",
        business_line:"Travel",
        product_category:"Car",
        business_line_product: "Hertz Premier Gold"
      },
      {
        clubCode: clubCode,
      });
    }else if(retry){

        // Wait for 2  seconds before trying again, but dont retry this time
        setTimeout(function(){
            logPageView_adobe(site, domain, page, clubCode,false);
        }, 2000);
    }
  }

  export async function LogLinkClick(site, domain, page, action,url,buttonText) {
    return new Promise((resolve) => {
      if (typeof adobeAnalytics_logEvent !== 'undefined') {
        adobeAnalytics_logEvent(adobeAnalyticsEvents.CTA_CLICK, {
            destination_url:url,
            button_text:buttonText,
            vendor_name: "Hertz",
            business_line:"Travel",
            cta_value:buttonText,
            product_category:"Car",
            business_line_product: "Hertz Premier Gold"
        },{});
      }else{
  
        // Stop now if we don't have the adobe analytics method
        return resolve();
      }
  
      // log to Tealium
      if (typeof AAAtag !== 'undefined')
        AAAtag.logEventAction(site, domain, page, 'LINKCLCK', action);
  
      // Wait a tiny bit,
      setTimeout(resolve, 200);
    });
  }

export async function logCustomEvent(site, domain, page, action,customEventType, customEventData) {
  return new Promise((resolve) => {
    if (typeof adobeAnalytics_logEvent !== 'undefined') {
      adobeAnalytics_logEvent(customEventType, {},{
        ...customEventData,
        vendor_name: "Hertz",
        business_line_product: "Hertz Premier Gold"
      });
    }else{

      // Stop now if we don't have the adobe analytics method
      return resolve();
    }

    // log to Tealium
    if (typeof AAAtag !== 'undefined')
      AAAtag.logEventAction(site, domain, page, 'LINKCLCK', action);

    // Wait a tiny bit,
    setTimeout(resolve, 200);
  });
}